<template>
    <ul>
        <job-sheet-entries-list-item
            v-for="entry in entries"
            :key="entry.uuid"
            :job-sheet="jobSheet"
            :entry="entry"
        />
    </ul>
</template>

<script>
    import JobSheetEntriesListItem from './job-sheet-entries-list-item'

    export default {
        components: {
            JobSheetEntriesListItem
        },
        props: {
            jobSheet: {
                type: Object,
                required: true
            },
            entries: {
                type: Array,
                required: true
            }
        }
    }
</script>
